import axios from 'axios';
import { createSignedGetRequest } from 'utils/createSignedRequestsHelpers';

export const getJydacomAssignmentsOfProject = async (projectId) => {
  const apiPath = `assignment/project/${projectId}/jydacom-assignments`;

  const signedRequest = await createSignedGetRequest({
    apiPath,
  });

  const response = await axios(signedRequest);

  return response.data;
};
